import AdvisoryActivitiesHeader from './component'
export default AdvisoryActivitiesHeader
